module.exports = __webpack_public_path__ + "static/media/TATASTEEL_F1.73303310.txt";